export interface IVerifyPhoneNumber {
  userId: string;
  phoneNumber: string;
  code: string;
}
